import { z } from "zod";
export const SsoProvider = z.object({
  providerId: z.string(),
  defaultAutoInviteValue: z.boolean(),
  autoInviteDomains: z.record(z.string(), z.boolean()),
  skipDocsSupernovaLogin: z.boolean(),
  areInvitesDisabled: z.boolean(),
  isTestMode: z.boolean(),
  emailDomains: z.array(z.string()),
  metadataXml: z.string().nullish(),
});

export type SsoProvider = z.infer<typeof SsoProvider>;
